import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeamlessRfViewDataService {
  sourceSelection: any;

  constructor(private http: HttpClient) { }

  getHeapMapsForSelectedSource(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getNowcastModelInputHeatMaps'
    return this.http.post<any>(url, postData)
  }

  getHeirarchy(postData) {
    let url = environment.url.OBSERVED_API_URL + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getSeamlessRainfallData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/nowcastInputData'
    return this.http.post<any>(url, postData)
  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_10MINS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_10MINS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString().padStart(2, '0') + ':' + startminutes.toString().padStart(2, '0') + ' ' + startamPm + ' - ' + endhours.toString().padStart(2, '0') + ':' + endminutes.toString().padStart(2, '0') + ' ' + endamPm;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    const date = new Date(ts);

    let hours = date.getHours();     // Local time hours
    const minutes = date.getMinutes();

    let amPm = hours >= 12 ? "P.M" : "A.M";

    // Convert to 12-hour format
    hours = hours % 12;
    if (hours === 0) hours = 12;

    // Format with leading zeros
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${amPm}`;
  }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getUpdatePostData(queryParams) {
    this.sourceSelection = queryParams['source'] == 'MODEL_INPUT_NOWCAST' ? 'RADAR_CTT_EUMETSAT_NOWCAST' : queryParams['source']
    let postData: any
    let allLocations = queryParams.location.split('&')
    let stateUUID;
    if (queryParams.locType == 'DISTRICT') {
      stateUUID = allLocations[1].split('##')[1]
    }
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(queryParams.locType) + 1];
    let firstLevel: any = hie[hie.indexOf(queryParams.locType) - 1];
    if (queryParams.locType == 'COUNTRY' || queryParams.locType == 'STATE') {
      postData = {
        "dataSrc": this.sourceSelection,
        "pUUID": queryParams.pUUID,
        "pType": queryParams.locType,
        "sUUID": queryParams.pUUID,
        "cType": currentLevel,
        "startTs": Number(queryParams.startDate),
        "endTs": Number(queryParams.endDate)
      }
    } else {
      postData = {
        "dataSrc": this.sourceSelection,
        "pUUID": queryParams.pUUID,
        "pType": queryParams.locType,
        "sUUID": stateUUID,
        "cType": currentLevel,
        "startTs": Number(queryParams.startDate),
        "endTs": Number(queryParams.endDate)
      }
    }
    return postData;
  }

  initializeDateDefaults() {
    const now = new Date();
    const start = new Date(now);

    // Set start time to 08:30:00
    start.setHours(8, 30, 0, 0);
    const startMs = start.getTime();
    const endMs = now.getTime();
    return { startTs: startMs, endTs: endMs }
  }
}
